module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Dependency on Services — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is determined (i) from the deceased's date of death to the deceased's 'but for' date\n        of death, and (ii) either applying a multiplicand based on average data within the tool for claims of a\n        similar type, or a multiplicand of £1,500. The period between death and assumed date of trial/settlement \n        is discounted by Table E Factor. The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fa8fb24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/lost/accordian-content/DependencyServicesModal.vue
// module id = 1684
// module chunks = 0